// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JA3bB","header":"styles_header__did2t","row":"styles_row__TZubJ","payWay":"styles_payWay__3mY6+","radio":"styles_radio__X9YJ4"};